<template>
	<div class = "pay-code-div">
		<div>
			<PhoneVerify :verifyType="verifyType" :mobile="phone" :verifyCount="verifyCount" @changeType="changeType" @back="aftVerify"></PhoneVerify>
			<Notes :hasPhone="phone && phone.length == 11"></Notes>
		</div>
		<van-field v-if="showCode" center clearable v-model = "code" type="digit" @input="changeInput" label="验证码" placeholder="请输入短信验证码" maxlength="6">
		 <template #button>
		    <van-button plain round size="small" type="primary" v-if="!code" :disabled="codeMsg != '获取验证码'" @click="getCode()">{{codeMsg}}</van-button>
		    <van-button plain round size="small" type="primary" v-if="code" :disabled="code.length != 6" @click="bind()">确认绑定</van-button>
		  </template>
		</van-field>
		
	</div>
</template>

<script>
	import {Field,Button,Notify} from 'vant';
	import { smsSend,bound } from '@/request/api';
	import PhoneVerify from '../phoneVerify/PhoneVerify.vue'
	import Notes from '../phoneVerify/Notes.vue'
	import { mapState, mapGetters, mapMutations, mapActions } from "vuex";
	export default {
		name: 'PhoneCode',
		components: {
		      [Field.name]: Field,
		      [Button.name]: Button,
		      [Notify.name]: Notify,
			  [PhoneVerify.name]: PhoneVerify,
			  [Notes.name]: Notes
		 },
		 props:['phone'],
		 data(){
			return {
				verifyCount:0,
				verifyType:0,
				showCode:false,
				showVerify:false,
				code:'',
				codeMsg:'获取验证码',
				codeTime:60,
				codeTimer:''
			}
		},
		methods:{
			...mapMutations(['sSetPhone']),
			changeType(type){
				this.verifyType = type
				if(type == 2){
					this.showCode = true
					this.getCode()
				}else{
					this.showCode = false
					this.code = ''
					this.verifyCount ++
				}
			},
			aftVerify(){
				this.bind()
				this.verifyCount = 0
				this.verifyType = 0
				this.showCode = false
				this.showVerify = false
			},
			changeInput(code){
				this.$emit('setCode',code)
			},
			bind(){
				bound({
					mobile:	this.phone,
					code:this.code
				}).then(res => {
					this.sSetPhone(this.phone);
					this.code  = '';
					this.showCode = false;
					this.stopCodeTimer();
					Notify({ type: 'success', message: '操作成功' });			
				    this.$emit('success')
				}) 
			},
			//获取验证码
			getCode(){
				//发送短信
				if(this.phone.length != 11){
					this.showCode = false;
					Notify({ type: 'danger', message: '手机号格式错误' });
				}else{
					//开启定时器
					this.codeMsg = this.codeTime + "秒后重试";
					this.codeTimer = setInterval(this.reduceTime, 1000);
					this.sendCode(this.phone);
				}
				
			},
			//axios获取验证码
			sendCode(phone){
				smsSend({
					mobile:	phone	  
				}).then(res => {
					Notify({ type: 'success', message: '验证码已发送' });					  
				}) 
			},
			//定时器-验证码
			reduceTime(){
				this.codeTime --;
				if(this.codeTime == 0){
					this.stopCodeTimer();
				}else{
					this.codeMsg = this.codeTime + "秒后重试";
				}
				
			},
			
			stopCodeTimer(){
				clearInterval(this.codeTimer);
				this.codeTime = 60;
				this.codeMsg = "获取验证码";
			}
		}
	}
</script>

<style>
	.pay-code-div .van-field__label {
		color: #2d2d2d;
		font-size: 15px;
	}
	
	.pay-code-div .van-button {
		width: auto;
		height: auto;
		margin: 0;
		padding: 8px;
		font-size: 13px;
	}
</style>
